export default "__VITE_ASSET__DtRSZWAj__"